import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDistributionReference } from "src/api/sure-api/useDistributionReference";

type ManagedDistributionSummary = {
    name: string;
    distributionReferenceId: number;
};

type DistributionSummary = {
    distributionReferenceId?: number | null;
    distribution?: ManagedDistributionSummary | null;
};
export const ProductDistributionSummary = (props: DistributionSummary) => {
    const { distribution, distributionReferenceId } = props;
    const { t } = useTranslation();

    const { distributionReference } = useDistributionReference();
    const selectedDistributionReferenceId = distribution?.distributionReferenceId ?? distributionReferenceId;

    if (selectedDistributionReferenceId === undefined || selectedDistributionReferenceId === null) {
        return (
            <Typography
                variant="h3"
                sx={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                }}
            >
                {t("product.distribution.no_mode_associated", "No distribution methods associated to this product")}
            </Typography>
        );
    }

    const foundDistribution = distributionReference?.find(
        (distribution) => distribution.id === selectedDistributionReferenceId,
    );

    const noValue = "-";
    const label = distribution?.name ?? foundDistribution?.label ?? noValue;

    return (
        <Box>
            <Typography variant="h4">{t("product.distribution.mode_label", "Product distribution method:")}</Typography>
            <Typography variant="body">{label}</Typography>
        </Box>
    );
};
